<template>
  <section class="employers-lt-first-section  container">
    <div class="employers-lt-first-section__content  container-inner">
      <div class="employers-lt-first-section__main">
        <div class="employers-lt-first-section__main-content">
          <h1 class="employers-lt-first-section__title">{{ $get(section, 'labels[0]') }}</h1>
          <div v-html="$get(section, 'labels[1]', '') + $get(section, 'labels[2]', '')"
               class="employers-lt-first-section__text  text">
          </div>
        </div>
        <div class="employers-lt-first-section__label">
          <div class="employers-lt-first-section__label-content">
            {{ $get(section, 'labels[3]', '') }}
            <template v-if="$get(section, 'labels[4]', '')">
              <br>
              {{$get(section, 'labels[4]', '')}}
            </template>
          </div>
        </div>
      </div>

      <picture class="employers-lt-first-section__img">
        <source v-if="section.image_mob_webp"
                :srcset="section.image_mob_webp"
                type="image/webp"
                :media="`(max-width: ${WINDOW_SIZE_SM}px)`">
        <source v-if="section.image_mob"
                :srcset="section.image_mob"
                :media="`(max-width: ${WINDOW_SIZE_SM}px)`">

        <source v-if="section.image_tablet_webp"
                :srcset="section.image_tablet_webp"
                type="image/webp"
                :media="`(max-width: ${WINDOW_SIZE_MD}px)`">
        <source v-if="section.image_tablet"
                :srcset="section.image_tablet"
                :media="`(max-width: ${WINDOW_SIZE_MD}px)`">

        <source v-if="section.image_small_pc_webp"
                :srcset="section.image_small_pc_webp"
                type="image/webp"
                :media="`(max-width: ${WINDOW_SIZE_LG}px)`">
        <source v-if="section.image_small_pc"
                :srcset="section.image_small_pc"
                :media="`(max-width: ${WINDOW_SIZE_LG}px)`">


        <source v-if="section.image_pc_webp"
                :srcset="section.image_pc_webp"
                type="image/webp">
        <img :src="section.image_pc"
             :alt="createAltMixin('')"
             :title="createTitleMixin('')">
      </picture>

    </div>
  </section>
</template>

<script>
  import {
    WINDOW_SIZE_LG,
    WINDOW_SIZE_MD,
    WINDOW_SIZE_SM
  } from '@/constants/windowSizes'

  export default {
    name: 'EmployersLTPageFirstSection',
    props: {
      section: Object
    },
    data() {
      return {
        WINDOW_SIZE_SM,
        WINDOW_SIZE_MD,
        WINDOW_SIZE_LG
      }
    }
  }
</script>

<style lang="less">

</style>
